import React from "react";
import { useTheme } from "@mui/material";
import { Area, XAxis, YAxis, CartesianGrid, ComposedChart, Tooltip, ResponsiveContainer } from "recharts";

export const AreaChart = ({
  chartData,
  height,
  xValuesDataKey,
  yValuesDataKey,
  customTooltip,
  customDot,
  customTickCount,
  customDomain,
  customTicks,
  xTicks,
  minimalGraph,
}) => {
  const theme = useTheme();
  return (
    <ResponsiveContainer width="100%" height={height}>
      <ComposedChart
        data={chartData}
        margin={{
          top: minimalGraph ? 10 : 30,
          right: minimalGraph ? 0 : 30,
          left: 0,
          bottom: 0,
        }}
      >
        <defs>
          <linearGradient id="areaFill" x1="0" y1="0" x2="1" y2="0">
            <stop offset="3.83%" stopColor="#9E67AB" stopOpacity={0.13} />
            <stop offset="21.9%" stopColor="#F37294" stopOpacity={0.13} />
            <stop offset="38.02%" stopColor="#F273A2" stopOpacity={0.13} />
            <stop offset="52.67%" stopColor="#8360A9" stopOpacity={0.13} />
            <stop offset="76.6%" stopColor="#4566B0" stopOpacity={0.13} />
            <stop offset="87.83%" stopColor="#3D83C2" stopOpacity={0.13} />
            <stop offset="97.6%" stopColor="#3EB8E1" stopOpacity={0.13} />
          </linearGradient>
        </defs>
        <CartesianGrid vertical={false} />
        <XAxis
          angle="-45"
          fontSize="10"
          minTickGap="0"
          dataKey={xValuesDataKey}
          tick={{ fill: theme.palette.speedometer.gray._400 }}
          axisLine={false}
          tickLine={false}
          interval={xTicks ? "preserveStartEnd" : undefined}
          ticks={xTicks}
        />
        <YAxis
          fontSize="10"
          dataKey={yValuesDataKey}
          tickCount={customTickCount ?? 5}
          domain={customDomain}
          ticks={customTicks}
          tick={{ fill: theme.palette.speedometer.gray._400 }}
          axisLine={false}
          tickLine={false}
          width={minimalGraph ? 30 : 60}
        />
        <Tooltip content={customTooltip} />

        <Area
          type="monotone"
          dataKey={yValuesDataKey}
          stroke={theme.palette.speedometer.pink.main}
          strokeWidth="2"
          fill="url(#areaFill)"
          isAnimationActive={false}
          dot={{
            stroke: "#fff",
            fill: theme.palette.speedometer.blue.lighter,
            r: 7,
            strokeWidth: 5,
            fillOpacity: 1,
          }}
          activeDot={{
            stroke: "#fff",
            fill: theme.palette.speedometer.blue.lighter,
            r: 7,
            strokeWidth: 5,
          }}
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};
